// src/pages/Moderation/ModerationQueuePage/ui/QueueHeader/QueueHeader.tsx
import React from 'react';
import './QueueHeader.scss';

export const QueueHeader: React.FC<{ title: string }> = ({ title }) => {
  return (
    <div className="queue-header">
      <div className="queue-header__title">{title}</div>
    </div>
  );
};
